import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const uploadFiles = async (uploadedMedia) => {
  if (uploadedMedia.length === 0)
    throw new Error("No files selected for upload");

  const fileData = uploadedMedia.map((media) => ({
    fileName: media.name,
    fileType: media.type,
  }));

  try {
    // Generate presigned URLs
    const response = await axios.post(
      `${API_BASE_URL}/aws/generate-presigned-url`,
      { files: fileData },
      { headers: { token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") } }
    );

    if (!response.data.success) {
      throw new Error("Failed to generate pre-signed URLs");
    }

    const preSignedUrls = response.data.directory;

    // Upload files to S3
    await Promise.all(
      preSignedUrls.map(async (item, index) => {
        await axios.put(item.presignedUrl, uploadedMedia[index], {
          headers: {
            "Content-Type": uploadedMedia[index].type,
            "Content-Encoding": "binary",
          },
        });
        console.log(`${item.fileName} uploaded successfully`);
      })
    );

    // Return uploaded file URLs
    return preSignedUrls.map((item) => ({
      media_type: item.fileType.startsWith("image") ? "image" : "pdf",
      url: item.fileUrl,
    }));
  } catch (error) {
    console.error("Upload error:", error);
    throw new Error("Failed to upload files. Please try again.");
  }
};

export default uploadFiles;
